class Exchange {
  constructor(data) {
    this.id = data.id;
    this.rate = data.Rate;
  }

};
export default Exchange;
